module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M10,11.53c-1,2.59-1.87,4.83-2.75,7.07-.17.44-.27.93-.79,1.2a1.52,1.52,0,0,1-1.57,0,1.07,1.07,0,0,1-.41-1.5c.78-1.94,1.42-3.93,2.3-5.84s.46-3.78.56-5.67C7.34,6,6.68,6,6,6H1.66C.8,6,0,5.84,0,5S.81,4,1.68,4H18.34C19.21,4,20,4.18,20,5s-.83,1-1.69,1c-1.4,0-2.8,0-4.2,0-1.1,0-1.34.31-1.46,1.21-.45,3.43,1.17,6.49,2.37,9.62.2.54.43,1.06.61,1.6a1.05,1.05,0,0,1-.77,1.5A1.37,1.37,0,0,1,13,19.1c-.8-2-1.57-4-2.35-6C10.5,12.71,10.31,12.3,10,11.53Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M9.86,0c1.28.08,2,.59,2.1,1.56S11.27,3.25,10,3.29,8.11,2.73,8,1.76,8.76.17,9.86,0Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09120094","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/ManSelfTraining.vue
// module id = 978d6b74455b5e887505
// module chunks = 89